import { svc_search, svc_addOne, svc_editOne } from "@/services";
import { message } from "antd";
import "lodash";
import logger from "@/utils/logger";

const endpointBasePrefix = "pos_discounts";

const Model = {
	namespace: "m_PosDiscount",
	state: {
		posdiscounts: [],
		scopeToken: {},
	},
	reducers: {
		handleFetchAll(state, { payload: { posdiscounts } }) {
			logger(`** PosDiscount reducers response ${JSON.stringify(posdiscounts)}`, 5);
			return { ...state, posdiscounts };
		}
	},
	effects: {
		*fetchAll({ brand, outlet, terminal, scopeToken }, { call, put }) {
			// console.log("*********************** brandId: ", brand)
			// console.log("*********************** outletId: ", outlet)
			// console.log("*********************** terminal: ", terminal)
			// console.log("Checking against scope ", scopeToken);

			let posdiscounts = yield call(svc_search, endpointBasePrefix, { brand, outlet, terminal });
			// let posdiscounts = yield call(posdiscount);

			_.forEach(posdiscounts, function (row) {
				row.key = row.id;
				row.is_deleted = !row.is_deleted;
				if (outlet && !scopeToken.allowedDerivedOutlets.includes(outlet)) row.disableEdit = true;
				if (brand && !outlet && !scopeToken.allowedBrands.includes(brand)) row.disableEdit = true;
			});
			// console.log("*********************** posdiscounts: ", posdiscounts)
			yield put({
				type: "handleFetchAll",
				payload: { posdiscounts },
			});
		},
		*addPosDiscount({ payload }, { call, put }) {
			let newPosDiscount = yield call(svc_addOne, endpointBasePrefix, payload);
			logger(("Created POS Discount: ", JSON.stringify(newPosDiscount)), 5);
			message.success("POS Discount created.");
		},
		*editPosDiscount({ payload }, { call, put }) {
			let newPosDiscount = yield call(svc_editOne, endpointBasePrefix, payload, "id");
			logger(("Created POS Discount: ", JSON.stringify(newPosDiscount)), 5);
			message.success("POS Discount edited.");
		}
	},
	subscriptions: {
		setup({ dispatch, history }) {
			return history.listen(({ pathname, query }) => {
				if (pathname === "/posdiscounts") {
					dispatch({ type: "fetch", payload: query });
				}
			});
		},
	},
};

export default Model;
